<template>
	<header class="view-layout-moduleheader module">
		<div>
			<h2>{{ title }}</h2>
			<p v-if="subtitle" class="type-small-paragraph color-chalky-grey-2">{{ subtitle }}</p>
		</div>

		<div class="actions">
			<slot></slot>
		</div>
	</header>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * This is often seen in the home feed or other places where there is
	 * a header module with complementary action.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Layout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewLayoutModuleHeader extends ViewBase {
		/**
		 * @type string
		 */
		@Prop()
		public subtitle!: string;

		/**
		 * @type string
		 */
		@Prop()
		public title!: string;
	}
</script>

<style lang="scss">
	.view-layout-moduleheader {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 1.5rem;
		margin-top: 0.5rem;
		position: relative;

		h2 {
			font-size: 1.125rem;
			font-weight: var(--font-weight-semibold);
		}

		.actions a {
			border: 0;
			color: var(--chalky-grey-2);
			font-size: 0.75rem;
			font-weight: var(--font-weight-regular);
			text-decoration: none;
			text-transform: uppercase;
			letter-spacing: 0.033rem;
		}
	}
</style>
